// extracted by mini-css-extract-plugin
module.exports = {"component":"hotel_component__iwQXm"};